import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {getToken, getPwdChangeAt} from '@/utils/auth' // getToken from cookie
import {Message} from 'element-ui'

NProgress.configure({ showSpinner: false })// NProgress Configuration

// permission judge function
function hasPermission (permissions, permissionsReq) {
  if (!permissionsReq || permissionsReq.length === 0) {
    return true
  }
  return permissions.some(permission => permissionsReq.includes(permission))
}

const whiteList = ['/login', '/auth-redirect']// no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (getToken()) { // determine if there has token
    /* has token */
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger afterEach hook, so manually handle it
    } else {
      if (!store.getters.isArch && !store.getters.userInfo) { // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetUserInfo').then(res => { // 拉取user_info
          const permissions = res.data.permissions // note: roles must be a array! such as: ['editor','develop']
          const isArch = res.data.is_arch
          store.dispatch('GenerateRoutes', { permissions, isArch }).then(() => { // 根据roles权限生成可访问的路由表
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          })
        }).catch(() => {
          console.log('FedLogOut')
          store.dispatch('FedLogOut').then(() => {
            next({ path: '/' })
          })
        })
      } else {
        if (to.path !== '/system/profile' && !getPwdChangeAt()) {
          if (from.path !== '/system/profile') {
            Message.error('您的密码过于简单，处于安全考虑，请先修改密码！')
            next({path: '/system/profile', replace: true, query: { active: '1' }})
          } else {
            Message.error('您的密码过于简单，处于安全考虑，请先修改密码！')
            NProgress.done()
          }
        } else {
          // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
          if (hasPermission(store.getters.permissions, to.meta.permissions)) {
            next()
          } else {
            next({path: '/401', replace: true, query: { noGoBack: true }})
          }
        }
      }
    }
  } else {
    /* has no token */
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js